export default __webpack_public_path__ + "static/media/logo.44c1aa10.jpg";